import React, { useEffect, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import api, { getErrorMessage } from '../../../services/api';
import { expedientStatusLabel } from '@claimup/shared/constants/expedient';

/**
 * Judiciales sin despacho: los que pasaron a judicial con un cliente que tiene
 * varios despachos (o ninguno). Nadie de fuera los ve hasta que se elige aquí.
 */
function UnassignedJudicial({ partners }) {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);

  const load = useCallback(() => {
    setLoading(true);
    api
      .get('/partners/unassigned-expedients')
      .then(({ data }) => {
        setItems(data.data.items || []);
        setTotal(data.data.total || 0);
      })
      .catch(err => toast.error(getErrorMessage(err)))
      .finally(() => setLoading(false));
  }, []);

  useEffect(load, [load]);

  const assign = async (expedientId, partnerId) => {
    if (!partnerId) return;
    try {
      await api.put(`/partners/expedients/${expedientId}`, { partner_id: partnerId });
      toast.success('Despacho asignado');
      load();
    } catch (err) {
      toast.error(getErrorMessage(err));
    }
  };

  if (loading) return <p className='text-sm text-slate-500'>Cargando…</p>;
  if (items.length === 0) return <p className='text-sm text-slate-500'>Todos los judiciales tienen despacho.</p>;

  return (
    <div>
      <p className='text-sm text-slate-600 mb-3'>
        {total} expedientes judiciales sin despacho. Hasta que se asignen, ningún despacho los ve.
      </p>
      <ul className='divide-y divide-slate-100 border border-slate-200 rounded-lg'>
        {items.map(e => {
          const clientId = String(e.user_id?._id || e.user_id || '');
          const candidates = partners.filter(p => (p.company_ids || []).map(String).includes(clientId));
          const debtor = e.deudores_id?.[0];
          return (
            <li key={e._id} className='flex flex-wrap items-center justify-between gap-3 px-4 py-3'>
              <div className='text-sm'>
                <Link to={`/view/${e._id}`} className='font-medium text-slate-800 hover:text-blue-600'>
                  {debtor?.debtorname || 'Deudor desconocido'}
                </Link>
                <div className='text-xs text-slate-500'>
                  {e.user_id?.username || e.user_id?.usermail} · {expedientStatusLabel(e.estado)}
                </div>
              </div>
              {candidates.length === 0 ? (
                <span className='text-xs text-amber-700'>Ningún despacho tiene a este cliente</span>
              ) : (
                <select
                  className='rounded-lg border-slate-300 text-sm'
                  defaultValue=''
                  onChange={ev => assign(e._id, ev.target.value)}
                >
                  <option value=''>Elegir despacho…</option>
                  {candidates.map(p => (
                    <option key={p._id} value={p._id}>
                      {p.username || p.usermail}
                    </option>
                  ))}
                </select>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default UnassignedJudicial;
